export const AlarmKmRange = ({ label, value, t }) => (
  <div className="flex flex-col gap-2 text-xs lg:text-sm py-1 w-52 pr-3 border-r-2 border-zinc-700">
    <div className="text-white text-xs lg:text-sm font-medium w-20">{label}</div>
    <div className="flex justify-between gap-2">
      <div className="flex">
        <div className="font-medium w-fit">{t("masters.fields.alrmRange")}</div>
        &nbsp;:&nbsp;
        <div className="">{value} KM</div>
      </div>
    </div>
  </div>
);

export const AlarmInfo = ({ label, value, text, t }) => (
  <div className="flex flex-col gap-2 text-xs lg:text-sm py-1 w-52 pr-3 border-r-2 border-zinc-700">
    <div className="text-white text-xs lg:text-sm font-medium">{label}</div>
    <div className="flex justify-between gap-2">
      <div className="flex">
        <div className="font-medium w-fit">{t("masters.fields.value")}</div>
        &nbsp;:&nbsp;
        <div className="">{value}</div>
      </div>
      {/* <div className="flex">
        <div className="font-medium w-fit">{t("masters.fields.text")}</div>
        &nbsp;:&nbsp;
        <div className="">{text}</div>
      </div> */}
    </div>
  </div>
);

// AlarmLimit.js
export const AlarmLimit = ({ label, min, max, t }) => (
  <div className="flex flex-col gap-2 text-xs lg:text-sm py-1 justify-between w-52 pr-3 border-r-2 border-zinc-700">
    <div className="flex">
      <label className="text-white text-xs lg:text-sm font-medium">
        {label}
      </label>
    </div>
    <div className="flex">
      <div className="flex gap-1">
        <label className="text-xs lg:text-sm w-1/2">
          {t("masters.fields.min")}
        </label>
        :<div className="ml-1">{min}</div>
      </div>
      <div className="flex gap-1 ml-6">
        <label className="text-xs lg:text-sm w-1/2">
          {t("masters.fields.max")}
        </label>
        :<div className="ml-1">{max}</div>
      </div>
    </div>
  </div>
);
